import React from "react";
import CommonModal from "../Modal";
import Button from "components/button/Button";
import {
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from "@chakra-ui/modal";

interface IModalDeleteConfirmation {
  isOpen: boolean;
  itemName?: string;
  itemId?: number;
  onClose: () => void;
  onDelete: (id: number | 0, slug: string | number | null) => void;
}

const ModalDeleteConfirmation: React.FC<IModalDeleteConfirmation> = (props) => {
  const { itemName, itemId, isOpen, onClose, onDelete } = props;

  return (
    <CommonModal
      size="2xl"
      children={
        <div>
          <ModalHeader>Konfirmasi</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className="flex flex-col gap-3">
              {itemName ? (
                <p className="text-base text-gray-700 dark:text-white">
                  Apakah anda yakin ingin menghapus <br />
                  <span className="text-brand-500">{itemName} ?</span>
                </p>
              ) : (
                <p className="text-base text-gray-700 dark:text-white">
                  Apakah anda yakin ingin menghapus ini?
                </p>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="flex gap-3">
              <Button
                size="fit"
                children="Batal"
                variant="gray"
                onClick={onClose}
              />
              <Button
                size="fit"
                children={<span className="text-white">Ya, hapus</span>}
                variant="danger"
                onClick={() => {
                  onClose();
                  onDelete(itemId, "");
                }}
              />
            </div>
          </ModalFooter>
        </div>
      }
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default ModalDeleteConfirmation;
